import { Component } from "react"
import PropTypes from "prop-types"
import Trigger from "partners/components/review/trigger"
import Query from "partners/components/review/query"
import Action from "partners/components/review/action"
import Admin from "partners/components/review/admin"
import * as DiffUtils from "partners/components/review/diff_utils"
import FeedbackContainer from "partners/components/review/feedback_container"
import ServiceTests from "partners/components/review/service_tests"
import BrandingAsset from "partners/components/review/branding_asset"
import ErrorIcon from "images/icons/icon-error.svg"

import last from "lodash/last"
import compact from "lodash/compact"
import find from "lodash/find"
import filter from "lodash/filter"
import _map from "lodash/map"

export default class Review extends Component {
  constructor(props) {
    super(props)
    // TODO fix this
    const diffStyles = this.availableDiffStyles()
    const currentDiffStyle = last(diffStyles) || null
    const serviceDetails = this.serviceDetails()
    const brandingDetails = this.brandingDetails()
    const marketingDetails = this.marketingDetails()
    const redirectDetails = this.redirectDetails()
    const changes = this.changesForDiffStyle(currentDiffStyle)
    this.state = {
      diffStyles,
      currentDiffStyle,
      serviceDetails,
      brandingDetails,
      marketingDetails,
      redirectDetails,
      changes,
      feedback: this.props.feedback,
    }
    this.changesForDiffStyle = this.changesForDiffStyle.bind(this)
    this.formatValue = this.formatValue.bind(this)
    this.actionSection = this.actionSection.bind(this)
    this.onFeedbackUpdated = this.onFeedbackUpdated.bind(this)
    this.setSessionFeedback = this.setSessionFeedback.bind(this)
    this.tableRow = this.tableRow.bind(this)
  }

  UNSAFE_componentWillMount() {
    if (window.sessionStorage.submenuIcons !== undefined) {
      window.sessionStorage.removeItem("submenuIcons")
    }

    window.sessionStorage.setItem("submenuIcons", JSON.stringify({}))
  }

  componentDidMount() {
    this.handleInvisibleIcons()
  }

  onFeedbackUpdated(feedbackUpdates) {
    this.setState({ feedback: feedbackUpdates })
    this.handleInvisibleIcons()
  }

  handleInvisibleIcons() {
    for (let key in JSON.parse(window.sessionStorage.getItem("submenuIcons"))) {
      $(`#${key}`).removeClass("icon-invisible")
    }
  }

  availableDiffStyles() {
    const diffStyles = []
    if (this.props.review.changes) {
      diffStyles.push("none")
      if (this.props.review.changes.from_published) {
        diffStyles.push("published")
      }
      if (this.props.review.changes.from_last_review) {
        diffStyles.push("review")
      }
    }
    return diffStyles
  }

  changesForDiffStyle(style) {
    if (style === "review") {
      return this.props.review.changes.from_last_review
    } else if (style === "published") {
      return this.props.review.changes.from_published
    }
    return { diffs: [] }
  }

  diffPicker() {
    if (this.state.currentDiffStyle && this.state.diffStyles.length) {
      const diffPickerElements = _map(this.state.diffStyles, style =>
        this.diffPickerElement(style)
      )
      return (
        <section className="review-section diff-picker">
          <p>Show changes:</p>
          <ul>{diffPickerElements}</ul>
        </section>
      )
    }
    return null
  }

  diffPickerElement(style) {
    let text = "Off"
    if (style === "review") {
      text = "vs last review"
    } else if (style === "published") {
      text = "vs published service"
    }
    return (
      <li
        key={style}
        className={style === this.state.currentDiffStyle ? "selected" : ""}
        onClick={
          style === this.state.currentDiffStyle
            ? null
            : () => {
                this.setState({
                  currentDiffStyle: style,
                  changes: this.changesForDiffStyle(style),
                })
              }
        }
      >
        {text}
      </li>
    )
  }

  feedbackContainer(items) {
    return (
      <FeedbackContainer
        feedbackItems={items.feedback}
        fieldName={items.name}
        service={this.props.service}
        pathObjs={items.pathObjs}
        onFeedbackUpdated={this.onFeedbackUpdated}
      />
    )
  }

  formatValue(value, field) {
    if (field.type === "url") {
      return (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      )
    }
    if (field.type === "email") {
      return <a href={`mailto:${value}`}>{value}</a>
    }
    if (field.type === "color") {
      const text = `#${value}`
      return (
        <div className="color-container">
          <span>{text}</span>
          <span
            className="color-swatch"
            style={{ backgroundColor: `${text}` }}
          />
        </div>
      )
    }
    if (field.type === "list" && !!value) {
      return <span>{value.join(", ")}</span>
    }
    if (field.type === "image" || field.type === "image-with-background") {
      const markFailedAsset = this.markFailedAsset.bind(this)
      return (
        <BrandingAsset
          type={field.type}
          value={value}
          fieldKey={field.key}
          markFailedAsset={markFailedAsset}
          {...this.props}
          {...this.state}
        />
      )
    }

    return value
  }

  serviceDetails() {
    return [
      { key: "name", name: "Name", required: true },
      { key: "description", name: "Description", required: true },
      { key: "category_name", name: "Category", required: true },
      {
        key: "home_url",
        name: "Official web page",
        required: true,
        type: "url",
      },
      {
        key: "support_email",
        name: "Support email",
        required: true,
        type: "email",
      },
      { key: "slug", name: "Slug", required: true },
      { key: "short_name", name: "Short name" },
      { key: "invite_url", name: "Invite URL", required: true, type: "url" },
      { key: "api_url_prefix", name: "API URL prefix", required: true },
    ]
  }

  brandingDetails() {
    return [
      { key: "color_hsl", name: "Brand color", required: true, type: "color" },
      {
        key: "lrg_monochrome_image_url",
        name: "Applet logo",
        required: true,
        type: "image-with-background",
      },
    ]
  }

  marketingDetails() {
    return [
      {
        key: "call_to_action_text",
        name: "Call to action button text",
        required: false,
      },
      {
        key: "call_to_action_link",
        name: "Call to action button URL",
        required: false,
      },
      {
        key: "alternate_search_terms",
        name: "Search term keyword",
        required: false,
        type: "list",
      },
    ]
  }

  redirectDetails() {
    return [
      {
        key: "embedded_redirects",
        name: "Approved redirect URIs",
        required: false,
        type: "list",
      },
    ]
  }

  setSessionFeedback(reviewSection, sessionStorage) {
    switch (reviewSection) {
      case "general":
        sessionStorage["generalFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "branding":
        sessionStorage["brandingFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "marketing":
        sessionStorage["marketingFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "redirects":
        sessionStorage["redirectsFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "admin":
        sessionStorage["adminsFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "triggers":
        sessionStorage["triggersFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "queries":
        sessionStorage["queriesFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "actions":
        sessionStorage["actionsFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "tests":
        sessionStorage["testsFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break

      case "auth":
        sessionStorage["authFeedback"] = true
        window.sessionStorage.setItem(
          "submenuIcons",
          JSON.stringify(sessionStorage)
        )
        break
    }
  }

  markFailedAsset(key) {
    let details = this.state.brandingDetails
    let detail = find(details, { key })
    detail.missing = true
    this.setState({ brandingDetails: details })
  }

  createDetailSection(details, collection, section) {
    const serviceDiffs = this.state.changes.diffs.filter(
      diff => diff.path && diff.path.length === 0
    )
    return details.map(detail => {
      let _detail = detail
      _detail.feedback =
        this.state.feedback.channel && this.state.feedback.channel[detail.key]
      _detail.value = collection[detail.key]

      let submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
      if (!!_detail.feedback && !submenuIcons[`${section}Feedback`]) {
        this.setSessionFeedback(section, submenuIcons)
      }

      _detail.pathObjs = ["channel", detail.key]
      if (this.state.currentDiffStyle !== "none") {
        _detail.diff = serviceDiffs.find(
          diff =>
            diff.data &&
            diff.data.property === detail.key &&
            (diff.data.from || diff.data.to)
        )
      } else {
        _detail.diff = null
      }
      return this.tableRow(_detail)
    })
  }

  serviceDetailSection() {
    const rows = this.createDetailSection(
      this.state.serviceDetails,
      this.props.review.channel,
      "general"
    )
    return (
      <section className="review-section service-details">
        <h2>General</h2>
        <table>
          <tbody>{rows}</tbody>
        </table>
      </section>
    )
  }

  brandingDetailSection() {
    const rows = this.createDetailSection(
      this.state.brandingDetails,
      this.props.review.channel,
      "branding"
    )
    return (
      <section className="review-section service-details">
        <a id="branding" />
        <h2>Branding</h2>
        <table>
          <tbody>{rows}</tbody>
        </table>
      </section>
    )
  }

  marketingDetailsSection() {
    const rows = this.createDetailSection(
      this.state.marketingDetails,
      this.props.service,
      "marketing"
    )
    return (
      <section className="review-section service-details">
        <a id="marketing" />
        <h2>Marketing</h2>
        <table>
          <tbody>{rows}</tbody>
        </table>
      </section>
    )
  }

  redirectsDetailsSection() {
    const rows = this.createDetailSection(
      this.state.redirectDetails,
      this.props,
      "redirects"
    )
    return (
      <section className="review-section service-details">
        <a id="redirects" />
        <h2>Redirects</h2>
        <table>
          <tbody>{rows}</tbody>
        </table>
      </section>
    )
  }

  adminSection() {
    const adminDiffs = filter(
      this.state.changes.diffs,
      diff => diff.data && diff.data.class === "channel_admin_role"
    )
    const admins = this.props.review.channel.channel_admin_roles.length ? (
      _map(this.props.review.channel.channel_admin_roles, admin => {
        let _admin = admin
        _admin.type = find(
          adminDiffs,
          diff => diff.event === "create" && diff.data.id === _admin.id
        )
          ? "new"
          : null
        let feedbackItems =
          this.state.feedback.channel &&
          this.state.feedback.channel.channel_admin_roles &&
          this.state.feedback.channel.channel_admin_roles[_admin.id]
        let submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
        if (!!feedbackItems && !submenuIcons["adminFeedback"]) {
          this.setSessionFeedback("admin", submenuIcons)
        }
        return (
          <Admin
            key={`admin-${_admin.user_id}`}
            values={admin}
            formatValue={this.formatValue}
            tableRow={this.tableRow}
            feedbackItems={feedbackItems}
            service={this.props.service}
            diffStyle={this.state.currentDiffStyle}
            onFeedbackUpdated={this.onFeedbackUpdated}
            feedbackContainer={this.feedbackContainer}
          />
        )
      })
    ) : (
      <h2>None</h2>
    )

    const deletedAdmins = compact(
      _map(this.state.changes.diffs, diff => {
        if (
          diff.event === "delete" &&
          diff.path &&
          diff.path[0] === "channel_admin_roles"
        ) {
          const deletedAdmin = find(
            this.state.changes.original_channel.channel_admin_roles,
            admin => admin.username === diff.path[1]
          )
          let feedbackItems =
            this.state.feedback.channel &&
            this.state.feedback.channel.channel_admin_roles &&
            this.state.feedback.channel.channel_admin_roles[deletedAdmin.id]
          deletedAdmin.type = "deleted"
          return (
            <Admin
              key={`admin-${deletedAdmin.user_id}`}
              values={deletedAdmin}
              formatValue={this.formatValue}
              tableRow={this.tableRow}
              feedbackItems={feedbackItems}
              service={this.props.service}
              diffStyle={this.state.currentDiffStyle}
              feedbackContainer={this.feedbackContainer}
            />
          )
        }
        return null
      })
    )

    return (
      <section className="review-section admin">
        <a id="admins" />
        <h2>Administrators</h2>
        {admins}
        {deletedAdmins}
      </section>
    )
  }

  serviceDetailRow(field) {
    return (
      <tr key={field.key}>
        <th>{field.name}</th>
        <td>{this.props.review.channel[field.key]}</td>
        <td className="feedback">
          <FeedbackContainer
            feedbackItems={field.feedback}
            fieldName={field.name}
            service={this.props.service}
            pathObjs={["channel", field.fieldName]}
            onFeedbackUpdated={this.onFeedbackUpdated}
          />
        </td>
      </tr>
    )
  }

  authenticationSection() {
    let reviewedAuthScheme = this.props.review.channel.auth_scheme

    let fields = [
      {
        key: "auth_scheme",
        name: "Scheme type",
        feedback: true,
        required: true,
        fieldName: "auth_scheme",
      },
    ]

    if (reviewedAuthScheme !== "no_oauth") {
      fields = fields.concat([
        {
          key: "oauth_client_id",
          name: "Client ID",
          feedback: true,
          required: true,
          fieldName: "oauth_client_id",
        },
        {
          key: "oauth_authorization_url",
          name: "Authorization URL",
          feedback: true,
          required: true,
          fieldName: "oauth_authorization_url",
        },
        {
          key: "oauth_token_url",
          name: "Token URL",
          feedback: true,
          required: true,
          fieldName: "oauth_token_url",
        },
        {
          key: "demo_account_login",
          name: "Demo account login",
          feedback: true,
          required: true,
          fieldName: "demo_account_login",
        },
        {
          key: "demo_account_password",
          name: "Demo account password",
          feedback: true,
          fieldName: "demo_account_password",
        },
        {
          key: "demo_account_notes",
          name: "Demo account notes",
          feedback: true,
          fieldName: "demo_account_notes",
        },
      ])
    }

    let rows = this.createDetailSection(
      fields,
      this.props.review.channel,
      "auth"
    )

    return (
      <section className="review-section authentication">
        <a id="authentication" />
        <h2>Authentication</h2>
        {rows ? (
          <table>
            <tbody>{rows}</tbody>
          </table>
        ) : null}
      </section>
    )
  }

  tableRow(field) {
    const cssClasses = []
    let displayValue = field.value
    let previousValue = null
    let feedback = null

    if (typeof displayValue === "string") {
      const replacer = /{{([\w\.]+)}}/g
      displayValue = displayValue.replace(
        replacer,
        "<span class='ingredient-pill'>$1</span>"
      )

      if (field.value !== displayValue) {
        field.transform = value => (
          <span dangerouslySetInnerHTML={{ __html: value }} />
        )
      }
    }
    if (
      (field.required && !field.value && field.value !== 0) ||
      field.missing === true
    ) {
      cssClasses.push("missing")
      displayValue = "Missing value"
    } else {
      if (field.type) {
        displayValue = this.formatValue(displayValue, field)
      }
      if (field.transform) {
        displayValue = field.transform(displayValue)
      }
    }

    if (field.diff) {
      cssClasses.push("changed")
      let previousDisplayValue = field.diff.data.from
      if (field.type) {
        previousDisplayValue = this.formatValue(previousDisplayValue, field)
      }
      if (field.transform) {
        previousDisplayValue = field.transform(previousDisplayValue)
      }
      previousValue = <div className="previous">{previousDisplayValue}</div>
      displayValue = <div className="updated">{displayValue}</div>
    }

    if (!field.noFeedbackAllowed) {
      feedback = this.feedbackContainer(field)
    }

    return (
      <tr className={cssClasses.join(" ")} key={`${field.key}`}>
        <th>
          {((field.required && !field.value && field.value !== 0) ||
            field.missing === true) && (
            <span dangerouslySetInnerHTML={{ __html: ErrorIcon }} />
          )}
          {field.name}
        </th>
        <td>
          {previousValue}
          {displayValue}
        </td>
        {!field.noFeedbackAllowed ? (
          <td className="feedback">{feedback}</td>
        ) : (
          <td className="no-feedback" />
        )}
      </tr>
    )
  }

  prepareCollectionForRender(items, collection) {
    const { diffs, original_channel } = this.state.changes
    if (this.state.currentDiffStyle !== "none") {
      const itemsDeleted = DiffUtils.collectionDeletedItems(
        diffs,
        original_channel,
        [collection]
      )
      items = items.concat(itemsDeleted)
    }

    return DiffUtils.setupCollectionForRender(diffs, items, [collection])
  }

  triggerSection() {
    const { diffs, original_channel } = this.state.changes
    const feedback =
      (this.state.feedback.channel && this.state.feedback.channel.triggers) ||
      {}
    const triggersReordered = DiffUtils.collectionWasReordered(diffs, [
      "triggers",
    ])

    const triggers = this.prepareCollectionForRender(
      this.props.review.channel.triggers,
      "triggers"
    )
    return (
      <section
        key={"triggers-${this.state.currentDiffStyle}"}
        className="review-section triggers"
      >
        <a id="triggers" />
        <h2>Triggers</h2>
        {this.state.currentDiffStyle !== "none" && triggersReordered && (
          <p>Triggers have been reordered.</p>
        )}
        {triggers.length > 0 ? (
          triggers.map(trigger => (
            <Trigger
              key={`trigger-${trigger.id}`}
              service={this.props.service}
              diffStyle={this.state.currentDiffStyle}
              platformServiceUrl={`/services/${this.props.service.slug}`}
              originalChannel={original_channel}
              trigger={trigger}
              changes={trigger.changes}
              status={trigger.type}
              feedbackItems={feedback[trigger.id]}
              tableRow={this.tableRow}
              setSessionFeedback={this.setSessionFeedback}
            />
          ))
        ) : (
          <h2>None</h2>
        )}
      </section>
    )
  }

  querySection() {
    const { diffs, original_channel } = this.state.changes
    const queriesReordered = DiffUtils.collectionWasReordered(diffs, [
      "queries",
    ])
    const feedback =
      (this.state.feedback.channel && this.state.feedback.channel.queries) || {}

    const queries = this.prepareCollectionForRender(
      this.props.review.channel.queries,
      "queries"
    )
    return (
      <section
        key={"queries-${this.state.currentDiffStyle}"}
        className="review-section queries"
      >
        <a id="queries" />
        <h2>Queries</h2>
        {this.state.currentDiffStyle !== "none" && queriesReordered && (
          <p>Queries have been reordered.</p>
        )}
        {queries.length > 0 ? (
          queries.map(query => (
            <Query
              key={`query-${query.id}`}
              service={this.props.service}
              diffStyle={this.state.currentDiffStyle}
              platformServiceUrl={`/services/${this.props.service.slug}`}
              originalChannel={original_channel}
              query={query}
              changes={query.changes}
              status={query.type}
              feedbackItems={feedback[query.id]}
              tableRow={this.tableRow}
              setSessionFeedback={this.setSessionFeedback}
            />
          ))
        ) : (
          <h2>None</h2>
        )}
      </section>
    )
  }

  actionSection() {
    const { diffs, original_channel } = this.state.changes
    const actionsReordered = DiffUtils.collectionWasReordered(diffs, [
      "actions",
    ])
    const feedback =
      (this.state.feedback.channel && this.state.feedback.channel.actions) || {}

    const actions = this.prepareCollectionForRender(
      this.props.review.channel.actions,
      "actions"
    )
    return (
      <section
        key={"actions-${this.state.currentDiffStyle}"}
        className="review-section actions"
      >
        <a id="actions" />
        <h2>Actions</h2>
        {this.state.currentDiffStyle !== "none" && actionsReordered && (
          <p>Actions have been reordered.</p>
        )}
        {actions.length > 0 ? (
          actions.map(action => (
            <Action
              key={`action-${action.id}`}
              service={this.props.service}
              diffStyle={this.state.currentDiffStyle}
              platformServiceUrl={`/services/${this.props.service.slug}`}
              originalChannel={original_channel}
              action={action}
              changes={action.changes}
              status={action.type}
              feedbackItems={feedback[action.id]}
              tableRow={this.tableRow}
              setSessionFeedback={this.setSessionFeedback}
            />
          ))
        ) : (
          <h2>None</h2>
        )}
      </section>
    )
  }

  testSection() {
    return (
      <ServiceTests
        onFeedbackUpdated={this.onFeedbackUpdated}
        submenuIcons={JSON.parse(window.sessionStorage.submenuIcons)}
        setSessionFeedback={this.setSessionFeedback}
        {...this.props}
        {...this.state}
      />
    )
  }

  render() {
    return (
      <article className="review-content">
        {this.diffPicker()}
        {this.serviceDetailSection()}
        {this.brandingDetailSection()}
        {this.marketingDetailsSection()}
        {this.adminSection()}
        {this.redirectsDetailsSection()}
        {this.triggerSection()}
        {this.querySection()}
        {this.actionSection()}
        {this.authenticationSection()}
        {this.testSection()}
      </article>
    )
  }
}

Review.propTypes = {
  authenticationTestUrl: PropTypes.string.isRequired,
  endpointTestUrl: PropTypes.string.isRequired,
  feedback: PropTypes.object.isRequired,
  progressChecklistUrl: PropTypes.string.isRequired,
  review: PropTypes.object.isRequired,
  service: PropTypes.object.isRequired,
  user_id: PropTypes.string.isRequired,
}
